import React, { useState } from 'react';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';
import definicoescliente from '../../definicoes-cliente.json';

interface PerguntasItem {
  Pergunta: string;
  Resposta: string;
}

const textData = {
  Titulo: 'Perguntas Frequentes',
};

const PerguntasData: PerguntasItem[] = [
  {
    Pergunta: 'Posso cancelar quando quiser?',
    Resposta: 'Claro que sim! Se os nossos serviços pararem de fazer sentido para você basta cancelar pelo aplicativo mesmo. Simples assim.'
  },
  {
    Pergunta: 'Como posso alterar meu plano?',
    Resposta: 'Você pode alterar seu plano diretamente pelo aplicativo em nossa aba de configurações.'
  },
  {
    Pergunta: 'Quais são os benefícios inclusos?',
    Resposta: 'Nossos benefícios incluem cobertura completa, assistência 24 horas, e muito mais.'
  }
];

const PerguntasAccordion: React.FC = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const alternaBotao = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div id="faq" className="w-full w-md mx-auto p-8 bg-theme-light-primary lg:px-14">
      <h2 className="text-textotitulo text-theme-primary font-bold text-center mb-4 mt-4">{definicoescliente?.Perguntas?.Titulo || textData.Titulo}</h2>
        {(definicoescliente.Perguntas.Perguntas.length ? definicoescliente.Perguntas.Perguntas : PerguntasData)
          .map((item, index) => (
        <div key={index} className="mb-3 bg-theme-primary rounded-md">
          <div
            onClick={() => alternaBotao(index)}
            className="p-3 cursor-pointer  flex justify-between items-center">
            <span className="font-medium text-theme-light-primary text-textopadrao">{item.Pergunta || PerguntasData[index]?.Pergunta}</span>
            <span className="text-theme-light-primary">
              {openIndex === index ? <FaChevronUp size={16}/> : <FaChevronDown size={16}/>}
            </span>
          </div>
          {openIndex === index && (
            <div className="p-3 text-theme-light-primary text-textopadrao">
              {item.Resposta || PerguntasData[index]?.Resposta}
            </div>
          )}
        </div> 
      ))}
    </div>
  );
};

export default PerguntasAccordion;
